<ng-container *ngIf="!(isKioskRoute$ | async) && (loggedIn$ | async); else noNavbar">
    <div class="navbar-container">
        <app-navbar></app-navbar>
    </div>

    <div class="router-outlet-container">
        <router-outlet></router-outlet>
    </div>
</ng-container>
<ng-template #noNavbar>
    <router-outlet></router-outlet>
</ng-template>